export const isEditSaveDisabled = ({
  submitting,
  pristine,
  isEditMode,
  extraDisabled = false,
  hasExternalChanges = false,
}) => submitting || extraDisabled || (isEditMode && pristine && !hasExternalChanges);
